import { render, staticRenderFns } from "./AdicionarRepertorio.vue?vue&type=template&id=a3fad82a&scoped=true&"
import script from "./AdicionarRepertorio.vue?vue&type=script&lang=js&"
export * from "./AdicionarRepertorio.vue?vue&type=script&lang=js&"
import style0 from "./AdicionarRepertorio.vue?vue&type=style&index=0&id=a3fad82a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fad82a",
  null
  
)

export default component.exports